import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, throwError, map } from 'rxjs';
import { SpinnerService } from '../services/spinner.service';

const SPINNER_DISAPPEAR_TIMEOUT = 500; // medio segundo

/**
 * Loading Interceptor to watch API calls
 * dispatch the open loader before each API
 * dispatch the hide loader after each API
 */
@Injectable()
export class LoadingInterceptor implements HttpInterceptor {
    constructor(private spinnerService: SpinnerService) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const url = request.url;
        if (request.headers.has('Silent-API') || url.includes('.json')) {
            return next.handle(request);
        }

        this.spinnerService.showSpinner();
        return next
            .handle(request)
            .pipe(
                catchError(err => {
                    this.hideSpinner();
                    return throwError(() => err);
                }),
            )
            .pipe(
                map<HttpEvent<any>, any>((evt: HttpEvent<any>) => {
                    if (evt instanceof HttpResponse) {
                        this.hideSpinner();
                    }
                    return evt;
                }),
            );
    }

    private hideSpinner() {
        setTimeout(() => {
            this.spinnerService.hideSpinner();
        }, SPINNER_DISAPPEAR_TIMEOUT);
    }
}
